import { useQuery } from "@tanstack/react-query";
import { useApi } from "~/hooks/use-api";
import { useProduct } from "~/contexts/product-context";

export const useAmplifyAPlusContent = () => {
  const api = useApi();
  const { product } = useProduct();
  const productId = product?.id;

  return useQuery({
    queryKey: ["product-amplify-a-plus-content", productId],
    queryFn: () => api.products.getAmplifyAPlusContent(productId!),
    enabled: !!productId,
  });
};
